import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

export const slice = createSlice({
	name: "statements",
	initialState,
	reducers: {
		replace: (state, { payload }) => [...payload],
		append: (state, { payload }) => [...state, ...payload],
		replaceStatement: (state, { payload: { statement } }) => {
			let index = state.findIndex((o) => o?.id === statement?.id);
			if (index >= 0) return [...state?.slice(0, index), { ...statement }, ...state?.slice(index + 1)];
			return state;
		},
		delete: () => initialState,
	},
});

export const statementsSelector = (state) => state?.statements || [];

export const { actions, reducer } = slice;

export default reducer;
